import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getPerformance } from "firebase/performance";
import devConfig from "../../firebase-config/dev.json";
import stageConfig from "../../firebase-config/stage.json";
import prodConfig from "../../firebase-config/prod.json";

export const init = () => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "test") {
    return;
  }

  const isBrowser =
    typeof window !== "undefined" && typeof window.document !== "undefined";
  const isFirebaseEnv =
    process.env.NEXT_PUBLIC_FIREBASE_ENV === "dev" ||
    process.env.NEXT_PUBLIC_FIREBASE_ENV === "stage" ||
    process.env.NEXT_PUBLIC_FIREBASE_ENV === "prod";

  if (isFirebaseEnv) {
    const app = initializeApp(firebaseConfigForFirebaseEnv());
    getFunctions(app);
    getAuth(app);

    if (isBrowser) {
      getPerformance(app);
    }
    return;
  }

  const app = initializeApp(devConfig);
  const functions = getFunctions(app);
  const db = getFirestore(app);

  if (process.env.NODE_ENV === "development") {
    // We need to point to some firebase environment in order to emulate it in local development, dev seemed like the best choice.
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
  }
};

const firebaseConfigForFirebaseEnv = () => {
  if (process.env.NEXT_PUBLIC_FIREBASE_ENV === "stage") {
    return stageConfig;
  } else if (process.env.NEXT_PUBLIC_FIREBASE_ENV === "prod") {
    return prodConfig;
  }
  return devConfig;
};
